export const FirstCap = (value: string | null | undefined): string => {
  if (!value) return '';

  if (value.toLocaleLowerCase() === 'read only') {
    return 'Read-Only';
  }
  if (value.toLocaleLowerCase() === 'free trial') {
    return 'Free Trial';
  }

  // const trimmed = value.trim();
  if (value.length === 0) return '';

  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const eachWordCap = (value: string): string => {
  return value
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const eachWordCapOrAllCap = (value: string): string => {
  return value
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const AllCap = (value: string): string => {
  return value.toUpperCase();
};

export const convertCamelCaseToLabel = (value: string): string => {
  const converted = (value.charAt(0).toUpperCase() + value.slice(1)).replace(
    /([a-z])([A-Z])/g,
    '$1 $2'
  );

  return converted;
};
